module.exports = __webpack_public_path__ + "img/H000180_starfish.0bf53538.png";